import { motion } from "framer-motion";

/**
 * Reusable scroll reveal wrapper.
 * NOTE: Replace/extend as sections grow.
 */
export const Reveal = ({
  children,
  delay = 0,
  y = 28,
  className = "",
  once = true,
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
